import { request } from '@/utils/ajax';
import { FrontEndConfiguration } from '@/types';

export function getConfiguration(): Promise<FrontEndConfiguration> {
    return request(`api/configuration/frontend`, {
        query: { domain: window.location.hostname },
    }).then((x) => x.json());
}